import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import "./depotName.component.scss";

@Component({
    selector: "depot",
    template: `<span><i class="material-icons s16">home</i> {{name}}</span>`
})
export class DepotNameComponent implements OnChanges {
    @Input() name: string;

    constructor() { }

    ngOnChanges(changes: SimpleChanges) {
    }
}
